import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=c5324854&scoped=true&"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js&"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=c5324854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5324854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})
